// extracted by mini-css-extract-plugin
module.exports = {"parameter-item":"JobSummaryCard_parameter-item_3PwqH"};